import { ReactNode } from 'react';

import { showModal } from 'zustand-stores/modalStore';

type Props = {
  type: 'warning' | 'danger';
  title?: string;
  buttonText: string;
  body?: ReactNode;
  onConfirm: () => Promise<void>;
  render: (arg0: { showModal: () => void }) => ReactNode;
  extraButtons?: ReactNode;
  'data-qa-id'?: string;
};

export function ShowConfirmationModal({
  type,
  title,
  buttonText,
  body,
  extraButtons,
  'data-qa-id': qaId,
  onConfirm,
  render,
}: Props) {
  const handleShowModal = () => {
    showModal('CONFIRMATION', {
      type,
      title,
      buttonText,
      body,
      onConfirm,
      extraButtons,
      'data-qa-id': qaId,
    });
  };

  return render({ showModal: handleShowModal });
}
